package com.example.mystybag.login.model

import androidx.compose.ui.graphics.Color

data class WelcomeUIState(
    val visualList                  : List<WelcomeVisualModel>  = listOf(),
    val backgroundColor             : Color?                    = null,
    val loginBtnColor               : Color?                    = null,
    val loginBtnTxtColor            : Color?                    = null,
    val createAccountBtnColor       : Color?                    = null,
    val createAccountTxtBtnColor    : Color?                    = null,
    val dotColor                    : Color?                    = null,
    val dotColorSelected            : Color?                    = null,
    val isLoading                   : Boolean                   = true,
    /** true = Client tab, false = Merchant tab (Figma segment control) */
    val isClientTabSelected         : Boolean                   = true
)
